import React from 'react';
import "./Project.css";


const Project = ({item, index}) => {
    return (            
        <div key={index} className="item">
            <img alt="post_image" src={item.img}/>

            <div className="item_info">
                <p className="info_name">{item.name}</p>
                <p className="info_description">
                    {item.description}
                </p>               
                <a target="_blank" rel="noopener noreferrer" href={item.link} className="info_button" >Live Preview</a>
            </div>
        </div>
       
  
    )
}

export default Project
